import Header from "../components/Header"
import "../Myprojects.css"
import OverviewTr from "./OverviewTr"
import DetailsTr from "./DetailsTr"
import ResouresTr from "./ResourcesTr"
import Model3d from "./Model3d"
import SubmissionFeedback from "./FeedBack&Sub"
import React, { useState,useEffect } from "react";
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import api from "views/auth/Api";
import { API_BASE_URL } from '../../../../configs/AppConfig';

const ProjectMainTrAssign = () => {
const [data , setData] = useState([]);
const [current , setCurrent] = useState("overview");
const [title , setTitle] = useState("");
const [subject , setSubject] = useState("");
const [proId , setProId] = useState("");
const [submission , setSubmission] = useState([]);
const { id } = useParams();
const navigate = useNavigate();
          console.log(submission,"submissionsubmission")

       useEffect(() => {
       api.get(`${API_BASE_URL}assigned-projects/teacher/${id}`)
        .then((response) => {  
          if (!response.data) {
            navigate(`/auth/not-found/`);
          }
          setData(response.data?.project);
          setTitle(response.data?.project?.projectName);
          setProId(response.data?.project?.id);
          setSubject(response.data?.project?.subject);
          setSubmission(response.data)
        })
        .catch((error) => {
          console.error('Error fetching card:', error);
        });
    }, [navigate,id]);


  const change = (page) => {
          setCurrent(page);
        }
  return (
    <div>
      <Header current = {current} change ={change} title={title} subject={subject} proId={proId} />
     {current ==="overview" ? <OverviewTr data={data} /> : null }
     {current ==="details" ? <DetailsTr data={data} /> : null }
     {current ==="resources" ? <ResouresTr data={data}/> : null }
     {current ==="model3d" ? <Model3d data={data}/> : null }
     {current ==="subFeed" ? <SubmissionFeedback submission={submission}/> : null }
    </div>
  );
};

export default ProjectMainTrAssign;
